<main class="main-content">
  <div class="cyberroom-layout">
    <div class="mobile-nav-overlay"
         [class.active]="isMobileNavOpen"
         (click)="closeMobileNav()">
    </div>
    <div class="content-wrapper">
      <div class="content-container">
        <router-outlet></router-outlet>
      </div>
      <simple-notifications></simple-notifications>
    </div>
  </div>
</main>
